// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".answer--answer--BSXHoQ5x {\n  width: 100%;\n  height: 100%;\n}\n.answer--answer--BSXHoQ5x .answer--noAnswer--36-vxAy2 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.answer--answer--BSXHoQ5x .answer--noAnswer--36-vxAy2.answer--noAnswer--36-vxAy2 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.answer--answer--BSXHoQ5x .answer--noAnswer--36-vxAy2.answer--noAnswer--36-vxAy2 svg {\n  fill: #979797;\n}\n", ""]);
// Exports
exports.locals = {
	"answer": "answer--answer--BSXHoQ5x",
	"noAnswer": "answer--noAnswer--36-vxAy2"
};
module.exports = exports;
